import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n";

export default function NotFound() {
  const { t, href } = useLang();
  useEffect(() => { const id = setTimeout(() => { document.title = `${t("notFound.title")} | PixelEdit Pro`; }, 0); return () => clearTimeout(id); }, [t]);
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6" data-testid="not-found-page">
      <p className="font-mono text-xs uppercase tracking-wider text-slate-400">404</p>
      <h1 className="mt-3 text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">{t("notFound.title")}</h1>
      <p className="mt-4 text-slate-600">{t("notFound.sub")}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild className="rounded-full bg-slate-900 text-white hover:bg-slate-800" data-testid="not-found-home"><Link to={href("home")}>{t("notFound.home")}</Link></Button>
        <Button asChild variant="outline" className="rounded-full" data-testid="not-found-tools"><Link to={href("tools")}>{t("notFound.tools")}</Link></Button>
      </div>
    </div>
  );
}
